var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{class:['v-icon', _vm.iconName, _vm.iconVariant, _vm.iconSize],style:(_vm.iconStyles),on:{"click":_vm.clicked}})}
var staticRenderFns = []

export { render, staticRenderFns }